import differenceInCalendarDays from'../differenceInCalendarDays/index.js';import startOfWeekYear from'../startOfWeekYear/index.js';import toDate from'../toDate/index.js';import toInteger from'../_lib/toInteger/index.js';import requiredArgs from'../_lib/requiredArgs/index.js';/**
 * @name setWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Set the local week-numbering year to the given date.
 *
 * @description
 * Set the local week-numbering year to the given date,
 * saving the week number and the weekday number.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} weekYear - the local week-numbering year of the new date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @returns {Date} the new date with the local week-numbering year set
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 *
 * @example
 * // Set the local week-numbering year 2004 to 2 January 2010 with default options:
 * var result = setWeekYear(new Date(2010, 0, 2), 2004)
 * //=> Sat Jan 03 2004 00:00:00
 *
 * @example
 * // Set the local week-numbering year 2004 to 2 January 2010,
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * var result = setWeekYear(new Date(2010, 0, 2), 2004, {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Sat Jan 01 2005 00:00:00
 */export default function setWeekYear(dirtyDate,dirtyWeekYear,dirtyOptions){requiredArgs(2,arguments);var options=dirtyOptions||{};var locale=options.locale;var localeFirstWeekContainsDate=locale&&locale.options&&locale.options.firstWeekContainsDate;var defaultFirstWeekContainsDate=localeFirstWeekContainsDate==null?1:toInteger(localeFirstWeekContainsDate);var firstWeekContainsDate=options.firstWeekContainsDate==null?defaultFirstWeekContainsDate:toInteger(options.firstWeekContainsDate);var date=toDate(dirtyDate);var weekYear=toInteger(dirtyWeekYear);var diff=differenceInCalendarDays(date,startOfWeekYear(date,dirtyOptions));var firstWeek=new Date(0);firstWeek.setFullYear(weekYear,0,firstWeekContainsDate);firstWeek.setHours(0,0,0,0);date=startOfWeekYear(firstWeek,dirtyOptions);date.setDate(date.getDate()+diff);return date;}